<template>
  <div class="sidebar">
    <el-menu
      :default-active="activeMenu"
      :default-openeds="openedMenus"
      class="el-menu-vertical"
      background-color="#fff"
      text-color="#333"
      active-text-color="#1890ff"
      @select="handleSelect"
    >
      <template v-for="item in menuItems" :key="item.path">
        <!-- 有子菜单的项 -->
        <el-sub-menu v-if="item.children && item.children.length" :index="item.path">
          <template #title>
            <el-icon>
              <component :is="getIconComponent(item.meta.icon)" />
            </el-icon>
            <span>{{ item.meta.title }}</span>
          </template>
          <el-menu-item 
            v-for="child in item.children" 
            :key="child.path" 
            :index="child.path"
          >
            <el-icon>
              <component :is="getIconComponent(child.meta.icon)" />
            </el-icon>
            <span>{{ child.meta.title }}</span>
          </el-menu-item>
        </el-sub-menu>
        
        <!-- 没有子菜单的项 -->
        <el-menu-item v-else :index="item.path">
          <el-icon>
            <component :is="getIconComponent(item.meta.icon)" />
          </el-icon>
          <span>{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { constantRoutes, generateMenuFromRoutes } from '../router'
import { House, UserFilled, Cpu, Key, CollectionTag } from '@element-plus/icons-vue'

// 图标名称到组件的映射
const iconComponents = {
  House,
  UserFilled,
  Cpu,
  Key,
  CollectionTag
}

export default {
  name: 'AppSidebar',
  components: {
    ...iconComponents
  },
  emits: ['navigate'],
  data() {
    return {
      activeMenu: '/',
      openedMenus: []
    }
  },
  computed: {
    // 从路由配置生成菜单项
    menuItems() {
      // 过滤出需要显示在侧边栏的路由
      const layoutRoute = constantRoutes.find(route => route.path === '/')
      if (layoutRoute && layoutRoute.children) {
        return generateMenuFromRoutes(layoutRoute.children)
      }
      return []
    },
    // 计算需要展开的父菜单路径
    computedOpenedMenus() {
      const opened = []
      const findParentPaths = (items, targetPath) => {
        for (const item of items) {
          if (item.path === targetPath) {
            return true
          }
          if (item.children) {
            if (findParentPaths(item.children, targetPath)) {
              opened.push(item.path)
              return true
            }
          }
        }
        return false
      }
      findParentPaths(this.menuItems, this.activeMenu)
      return opened
    }
  },
  watch: {
    // 监听路由变化，更新激活状态
    '$route.path'(newPath) {
      // 将 /index 映射为 / 以保持兼容性
      const mappedPath = newPath === '/index' ? '/' : newPath
      this.activeMenu = mappedPath
      this.openedMenus = this.computedOpenedMenus
    }
  },
  mounted() {
    // 初始化激活状态
    const mappedPath = this.$route.path === '/index' ? '/' : this.$route.path
    this.activeMenu = mappedPath
    this.openedMenus = this.computedOpenedMenus
  },
  methods: {
    getIconComponent(iconName) {
      return iconComponents[iconName] || House
    },
    handleSelect(index) {
      this.activeMenu = index
      this.$emit('navigate', index)
      // 所有菜单项都对应有效路由，直接跳转
      this.$router.push(index)
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 100%;
  height: 100%;
}

.el-menu-vertical {
  border-right: 1px solid #eee;
  height: 100%;
}

/* 自定义菜单样式 */
:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
  margin: 4px 8px;
  border-radius: 6px;
}

:deep(.el-sub-menu__title) {
  height: 50px;
  line-height: 50px;
  margin: 4px 8px;
  border-radius: 6px;
}

:deep(.el-menu-item:hover),
:deep(.el-sub-menu__title:hover) {
  background-color: #f0f5ff !important;
  color: #1890ff !important;
}

:deep(.el-sub-menu .el-menu-item) {
  height: 40px;
  line-height: 40px;
  margin: 2px 8px;
  font-size: 13px;
}
</style>
